import * as React from 'react';

import { Props as IconProps } from 'components/Icon';
import SVGs from 'components/SVGs';
import { ICONS } from 'constants/IconConstants';

type SharedSVGBaseProps = {
  viewBox: string;
  path?: React.ReactElement | null;
  svgProps?: { height: number; width: number };
} & Partial<IconProps>;

type SVGBaseProps = {
  viewBox?: string;
} & Partial<IconProps>;

const SharedSVGBase: React.FC<SharedSVGBaseProps> = ({
  altText,
  ariaHidden,
  children,
  className,
  path,
  svgProps,
  viewBox,
  ...otherProps
}) => {
  return (
    // wrapper around svg to handle things like onFocus, onBlur, etc.
    <div style={{ display: 'inline-block' }} {...otherProps}>
      <svg
        aria-hidden={ariaHidden}
        className={className}
        viewBox={viewBox}
        xmlns="http://www.w3.org/2000/svg"
        {...svgProps}
      >
        {altText && <title>{altText}</title>}
        {path}
        {children}
      </svg>
    </div>
  );
};

const SVGBase: React.FC<SVGBaseProps> = ({ name, size, viewBox = '0 0 32 32', ...props }) => {
  const isModernSVG = !!SVGs[name as keyof typeof SVGs];
  if (isModernSVG) {
    const svgProps = typeof size === 'number' ? { height: size, width: size } : undefined;

    return <SharedSVGBase {...props} svgProps={svgProps} viewBox={viewBox} />;
  } else if (ICONS[name as keyof typeof ICONS] || !name || !viewBox) {
    const path =
      name && ICONS[name as keyof typeof ICONS] ? (
        <path d={ICONS[name as keyof typeof ICONS]} />
      ) : null;

    return (
      <SharedSVGBase
        {...props}
        path={path}
        svgProps={{ height: 32, width: 32 }}
        viewBox={viewBox}
      />
    );
  }

  return null;
};

export default SVGBase;
